export default __webpack_public_path__ + "static/media/taittinger.5f16fc04.png";